module.exports = __webpack_public_path__ + "img/4.d00d135e.jpg";